<template>
  <div>

    <validation-observer ref="form">
      <b-form @submit.prevent="saveNaturalEntity">
        <div v-if="naturalEntity">

          <div class="vx-row">

            <div class="vx-col w-full mb-2" v-if="!isEmployee">

              <b-form-group
                label="Pronome de Tratamento"
                label-for="pronoun_treatment"
              >
                <validation-provider
                  #default="{ errors }"
                  name="pronoun_treatment"
                >
                  <v-select v-model="naturalEntity.pronounTreatment" :options="pronounTreatmentList" label="name">
                    <div slot="no-options">Nenhum registro encontrado!</div>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </div>

          </div>

          <div class="vx-row">

            <div class="vx-col w-full mb-2 sm:w-4/12">

              <b-form-group
                  label="Nome"
                  label-for="first_name"
                >
                <validation-provider
                  #default="{ errors }"
                  name="Nome"
                  rules="required"
                >
                  <b-form-input
                    id="first_name"
                    v-model="naturalEntity.first_name"
                    :state="errors.length > 0 ? false:null"
                    name="first_name"
                    class="required"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </div>

            <div class="vx-col w-full mb-2 sm:w-8/12">

              <b-form-group
                  label="Sobrenome"
                  label-for="surname"
                >
                <validation-provider
                  #default="{ errors }"
                  name="Sobrenome"
                  rules="required"
                >
                  <b-form-input
                    id="surname"
                    v-model="naturalEntity.surname"
                    :state="errors.length > 0 ? false:null"
                    name="surname"
                    class="required"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </div>

          </div>

          <div>
            <div class="vx-col w-full mb-2" v-if="isEmployee">

              <b-form-group
                label="Cargo"
                label-for="position"
              >
                <validation-provider
                  #default="{ errors }"
                  name="position"
                  rules="required"
                >
                  <v-select v-model="naturalEntity.position" :options="positionList" label="name" class="required-select">
                    <div slot="no-options">Nenhum registro encontrado!</div>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <label>Data Nascimento</label>
              <datepicker
                v-model="naturalEntity.birth_date"
                :format="format"
                :language="ptBR"
                typeable="true"
                v-mask="['##/##/####']"
              ></datepicker>
              <!-- <span
                class="text-danger text-sm"
                v-show="errors.has('birth_date')"
              >{{ errors.first('birth_date') }}</span> -->
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-2">

              <b-form-group
                label="Estado Civil"
                label-for="marital_status"
              >
                <validation-provider
                  #default="{ errors }"
                  name="marital_status"
                >
                  <v-select v-model="naturalEntity.maritalStatus" :options="maritalStatusList" label="name">
                    <div slot="no-options">Nenhum registro encontrado!</div>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </div>

            <div class="vx-col sm:w-1/3 w-full mb-2">

              <b-form-group
                label="Sexo"
                label-for="gender"
              >
                <validation-provider
                  #default="{ errors }"
                  name="gender"
                >
                  <v-select v-model="naturalEntity.gender" :options="genderList" label="name">
                    <div slot="no-options">Nenhum registro encontrado!</div>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/3 w-full mb-2">

              <b-form-group
                  label="CPF"
                  label-for="natural_entity_number"
              >
                <validation-provider
                  #default="{ errors }"
                  name="natural_entity_number"
                >
                  <b-form-input
                    id="natural_entity_number"
                    v-model="naturalEntity.natural_entity_number"
                    :state="errors.length > 0 ? false:null"
                    name="natural_entity_number"
                    v-mask="'###.###.###-##'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </div>

            <div class="vx-col sm:w-1/3 w-full mb-2">

              <b-form-group
                label="RG"
                label-for="identity_number"
              >
                <validation-provider
                  #default="{ errors }"
                  name="CNPJ"
                >
                  <b-form-input
                    id="identity_number"
                    v-model="naturalEntity.identity_number"
                    :state="errors.length > 0 ? false:null"
                    name="identity_number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </div>

            <div class="vx-col sm:w-1/3 w-full mb-2">
              <label>Data Expedição</label>
              <datepicker
                v-model="naturalEntity.identity_number_issued_at"
                :format="format"
                :language="ptBR"
                typeable="true"
                v-mask="['##/##/####']"
              ></datepicker>
              <!-- <span
                class="text-danger text-sm"
                v-show="errors.has('identity_number_issued_at')"
              >{{ errors.first('identity_number_issued_at') }}</span> -->
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">

              <b-form-group
                label="Estado Nascimento"
                label-for="federation_unit"
              >
                <validation-provider
                  #default="{ errors }"
                  name="federation_unit"
                >
                  <v-select
                    :options="federationUnitList"
                    label="name"
                    @input="selectFederationUnit"
                    v-model="federationUnit"
                  >
                    <div slot="no-options">Nenhum registro encontrado!</div>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </div>

            <div class="vx-col sm:w-1/2 w-full mb-2">

              <b-form-group
                label="Cidade Nascimento"
                label-for="born_city_id"
              >
                <validation-provider
                  #default="{ errors }"
                  name="born_city_id"
                >
                  <v-select
                    :options="cityList"
                    label="name"
                    v-model="naturalEntity.bornCity"
                    :disabled="!showCityList"
                  >
                    <div slot="no-options">Nenhum registro encontrado!</div>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </div>
          </div>

          <!-- <div class="vx-row" v-if="!hide_spouse">
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <label>Cônjuge:</label>

              <vx-input-group class="mb-base">
                <vs-input disabled :value="spouseFullName" />

                <template slot="append">
                  <div class="append-text btn-addon">
                    <vs-button
                      color="primary"
                      type="border"
                      icon="search"
                      title="Buscar"
                      @click="showSpouseSearchGrid = true"
                    ></vs-button>
                    <vs-button
                      color="primary"
                      type="border"
                      icon="add"
                      title="Incluir"
                      @click="showNaturalEntityCreateForm()"
                    ></vs-button>
                    <vs-button
                      color="primary"
                      type="border"
                      icon="clear"
                      title="Limpar"
                      @click="naturalEntity.spouse = null"
                    ></vs-button>
                  </div>
                </template>
              </vx-input-group>

              <span
                class="text-danger text-sm"
                v-show="errors.has('spouse_id')"
              >{{ errors.first('spouse_id') }}</span>
            </div>
          </div> -->

          <div class="vx-row" v-if="!isComplement">
            <div class="vx-col w-full">

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-secondary"
                @click="cancel"
                class="mt-5 float-right">
                Cancelar
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-5 mr-2 float-right"
                :disabled="!validateForm"
                type="submit">
                Salvar
              </b-button>

            </div>
          </div>
        </div>
      </b-form>
    </validation-observer>

    <vs-popup title="Pessoa Natural" :active.sync="showSpouseSearchGrid">
      <Grid
        :service="naturalEntityService"
        route_name="natural_entities"
        hide_actions="true"
        :delegate="itemSelected"
      ></Grid>
    </vs-popup>
  </div>
</template>


<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BButton, BFormInput, BFormGroup, BInputGroup
} from 'bootstrap-vue'
import { required, email } from '@validations'

import Datepicker from 'educatena-vuejs-datepicker'
import { ptBR } from 'educatena-vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import Constants from '../../../../util/Constants'
import Phone from './Phone'
import NaturalEntityService from '@/services/api/NaturalEntityService'

export default {
  components: {
    Datepicker,
    vSelect,
    Phone,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    naturalEntityId: {
      type: Number,
      default: null
    },
    naturalEntity: {
      type: Object,
      default: null
    },
    services: {
      type: Object,
      default: null
    },
    hide_spouse: {
      type: Boolean,
      default: false
    },
    isEmployee: {
      type: Boolean,
      default: false
    },
    employee: {
      type: Object,
      default: null
    },
    isComplement: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    format: 'dd/MM/yyyy',
    ptBR,
    federationUnit: null,
    federationUnitList: [],
    cityList: [],
    pronounTreatmentList: [],
    positionList: [],
    showSpousePopup: false,
    naturalEntityService: null,
    showSpouseSearchGrid: false,
    createEnabled: false,
    completed: false,
    // validation rules
    required,
    email,
  }),
  computed: {
    validateForm() {
      return (
        !this.isEmpty(this.naturalEntity.first_name) &&
        !this.isEmpty(this.naturalEntity.surname) &&
        this.createEnabled
      )
    },
    maritalStatusList() {
      return Constants.MARITAL_STATUS
    },
    genderList() {
      return Constants.GENDERS
    },
    showCityList() {
      return this.cityList.length > 0
    },
    spouseFullName() {
      return this.naturalEntity.spouse
        ? this.naturalEntity.spouse.full_name
        : ''
    }
  },
  watch: {
    naturalEntity(val) {
      if (val === null) {
        this.load()
      }
    }
  },
  methods: {
    isCompleted() {
      return this.isCompleted
    },
    saveNaturalEntity() {
      this.$refs.form.validate().then(success => {
        if (success) {

          this.clearErrors(this.$refs.form)
          this.$vs.loading()

          const gender = this.naturalEntity.gender
          const maritalStatus = this.naturalEntity.maritalStatus
          const bornCity = this.naturalEntity.bornCity

          const naturalEntityNumber = !this.isEmpty(
            this.naturalEntity.natural_entity_number
          )
            ? this.clearDashDots(this.naturalEntity.natural_entity_number)
            : ''

          const naturalEntity = !this.hide_spouse
            ? this.naturalEntity
            : null
          const peopleId = naturalEntity && naturalEntity.people ? naturalEntity.people.id : null
          const isCreate = peopleId === null

          this.services.naturalEntityService
            .createOrUpdate({
              people_id: peopleId,
              id: this.naturalEntity.id,
              first_name: this.naturalEntity.first_name,
              surname: this.naturalEntity.surname,
              birth_date: this.naturalEntity.birth_date
                ? this.$moment(this.naturalEntity.birth_date).format('YYYY-MM-DD')
                : null,
              gender: gender ? gender.code : null,
              natural_entity_number: naturalEntityNumber,
              identity_number: this.naturalEntity.identity_number,
              identity_number_issued_at: !this.isEmpty(
                this.naturalEntity.identity_number_issued_at
              )
                ? this.$moment(this.naturalEntity.identity_number_issued_at).format(
                    'YYYY-MM-DD'
                  )
                : null,
              marital_status: maritalStatus ? maritalStatus.code : null,
              born_city_id: bornCity ? bornCity.id : null,
              spouse_id: this.naturalEntity.spouse
                ? this.naturalEntity.spouse.id
                : null,
              pronoun_treatment_id: this.naturalEntity.pronounTreatment ? this.naturalEntity.pronounTreatment.id : null,
              is_employee: this.isEmployee,
              position_id: this.naturalEntity.position ? this.naturalEntity.position.id : null
            })
            .then(
              data => {

                if (this.employee === null) {
                  this.employee = {
                    id: this._.get(data, 'employee.id'),
                    position_id: this._.get(this.naturalEntity, 'position.id')
                  }
                }

                this.fillNaturalEntity(data)
                this.$vs.loading.close()
                this.notifySuccess(this.$vs)

                if (isCreate) {
                  if (this.hide_spouse) {
                    this.$root.$emit('naturalEntityCreated', data)
                    this.clearFields()
                    this.clearErrors(this.$validator)
                  } else {

                    if (!this.isComplement) {
                      if (this.isEmployee) {
                        this.$router.push(`/people/employees/${data.employee.id}/edit`)
                      } else {
                        this.$router.push(`/people/natural_entities/${data.id}/edit`)
                      }
                      this.$root.$emit('naturalEntityCreated', data)
                    }

                  }
                }

                this.completed = true

                this.$emit("created", data)
              },
              error => {
                this.$vs.loading.close()
                this.showErrors(this.$refs.form, error, this)
                this.$root.$emit('naturalEntityError', error)
              }
            )

        }
      })
    },
    cancel() {
      this.$emit('close')
      if (this.hide_spouse) {
        this.$root.$emit('naturalEntityClosed')
        this.clearFields()
        this.clearErrors(this.$validator)
      } else {

        if (this.isEmployee) {
          this.$router.push(`/people/employees`)
        } else {
          this.$router.push('/people/natural_entities')
        }

      }
    },
    selectFederationUnit(federationUnit, cityId) {
      this.naturalEntity.bornCity = null
      this.cityList = []
      if (federationUnit) {
        this.$vs.loading()
        this.services.cityService
          .findAllByFederationUnity(federationUnit.id)
          .then(
            data => {
              this.cityList = data

              if (cityId) {
                if (this.federationUnitList) {
                  const federationUnitSelect = this.federationUnitList.find(
                    element => {
                      return element.id === federationUnit.id
                    }
                  )
                  this.federationUnit = federationUnitSelect
                }

                const city = this.cityList.find(element => {
                  return element.id === cityId
                })
                this.naturalEntity.bornCity = city
              }

              this.$vs.loading.close()
            },
            error => {
              this.$vs.loading.close()
            }
          )
      }
    },
    itemSelected(naturalEntity) {
      this.naturalEntity.spouse = naturalEntity
      this.showSpouseSearchGrid = false
    },
    showNaturalEntityCreateForm() {
      this.$root.$emit('showNaturalEntityCreateForm')
    },
    clearFields() {
      this.naturalEntity = {
        id: null,
        first_name: null,
        surname: null,
        natural_entity_number: null,
        identity_number: null,
        identity_number_issued_at: null,
        birth_date: null,
        maritalStatus: null,
        gender: null,
        bornCity: null,
        spouse: null,
        people: null,
        pronounTreatment: null
      }
    },
    getAllPronounTreatment() {
      this.services.pronounTreatmentService
        .all()
        .then(
          data => {
            this.pronounTreatmentList = data
            this.$vs.loading.close()
          },
          error => {
            this.$vs.loading.close()
          }
        )
    },
    getAllPosition() {
      if (this.services.positionService) {
        this.services.positionService
          .all()
          .then(
            data => {
              this.positionList = data

              if (this.employee && this.positionList && this.positionList.length > 0) {
                this.naturalEntity.position = this.positionList.filter(position => {
                  return position.id === this.employee.position_id
                })
              }

              this.$vs.loading.close()
            },
            error => {
              this.$vs.loading.close()
            }
          )
      }
    },
    fillNaturalEntity(naturalEntity) {
      this.isCompleted = true
      this.naturalEntity = {}
      this.naturalEntity.id = naturalEntity.id
      this.naturalEntity.first_name = naturalEntity.first_name
      this.naturalEntity.surname = naturalEntity.surname
      this.naturalEntity.natural_entity_number =
        naturalEntity.natural_entity_number
      this.naturalEntity.identity_number = naturalEntity.identity_number
      this.naturalEntity.identity_number_issued_at =
        naturalEntity.identity_number_issued_at
      this.naturalEntity.birth_date = naturalEntity.birth_date
      this.naturalEntity.spouse = naturalEntity.spouse
      this.naturalEntity.people = naturalEntity.people
      this.naturalEntity.pronounTreatment = naturalEntity.pronoun_treatment

      const maritalStatus = this.maritalStatusList.find(element => {
        return element.code === naturalEntity.marital_status
      })
      this.naturalEntity.maritalStatus = maritalStatus

      const gender = this.genderList.find(element => {
        return element.code === naturalEntity.gender
      })
      this.naturalEntity.gender = gender

      this.getAllPosition()

      this.$store
        .dispatch('common/fetchFederationUnit')
        .then(federationUnitList => {
          this.federationUnitList = federationUnitList
          if (naturalEntity.born_city) {
            this.selectFederationUnit(
              naturalEntity.born_city.federation_unit,
              naturalEntity.born_city.id
            )
          }
          this.$root.$emit('federationUnitUpdated')
        })

      // this.$store.commit(
      //   'naturalEntity/UPDATE_NATURAL_ENTITY',
      //   naturalEntity
      // )
      // this.$root.$emit('naturalEntityUpdated')

      this.$root.$emit('natural-entity:loaded', this.naturalEntity)
    },
    load() {
      this.$vs.loading()
      this.getAllPronounTreatment()

      if (this.isEmployee) {
        this.getAllPosition()
      }

      this.$root.$on('naturalEntityCreated', naturalEntity => {
        if (this.naturalEntity) {
          this.naturalEntity.spouse = naturalEntity
        }
      })

      if (this.isEmployee && this.naturalEntity !== null) {
        this.fillNaturalEntity(this.naturalEntity)
        this.createEnabled = true
        this.$vs.loading.close()
      } else if (this.naturalEntityId !== null) {
        this.services.naturalEntityService
          .read(this.naturalEntityId)
          .then(naturalEntity => {

            this.fillNaturalEntity(naturalEntity)
            this.createEnabled = true
            this.$vs.loading.close()
          })
      } else {
        this.createEnabled = true
        this.$store
          .dispatch('common/fetchFederationUnit')
          .then(federationUnitList => {
            this.federationUnitList = federationUnitList
            this.$root.$emit('federationUnitUpdated')
          })
      }
    }
  },
  created() {
    const onEscape = e => {
      if (e.keyCode === 27) {
        this.showSpouseSearchGrid = false
      }
    }
    document.addEventListener('keydown', onEscape)
  },
  beforeMount() {

    if (this.naturalEntity === null) {
      this.naturalEntity = {
        id: null,
        first_name: null,
        surname: null,
        natural_entity_number: null,
        identity_number: null,
        identity_number_issued_at: null,
        birth_date: null,
        maritalStatus: null,
        gender: null,
        bornCity: null,
        spouse: null,
        people: null,
        pronounTreatment: null,
        position: null
      }
    }

    this.naturalEntityService = NaturalEntityService.build(this.$vs)
  },
  mounted() {
    this.load()
  }
}
</script>
